<template>
  <v-card class="gallery">
    <template v-if="mediaDetail">
      <v-btn
        fab
        color="#fff"
        @click.native="closeVideoPage"
        class="dialog-close"
      >
        <v-icon color="#000">fas fa-xmark</v-icon>
      </v-btn>
      <v-row no-gutters>
        <v-col cols="12" :md="8" :lg="8">
          <div class="gallery-content">
            <iframe
              width="100%"
              height="100%"
              :src="`https://www.youtube.com/embed/${mediaDetail.youtubeId}?autoplay=1`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            >
            </iframe>
          </div>
        </v-col>
        <v-col cols="12" :md="4" :lg="4">
          <GalleryPanel :mediaDetail="mediaDetail" />
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <SlideMedia />
    </template>
  </v-card>
</template>
<script>
import GalleryPanel from "@/components/Courses/GalleryPanel";
import SlideMedia from "@/components/Media/SlideMedia";
export default {
  name: "Video",
  props: {
    mediaDetail: Object,
    isEmmit: Boolean,
  },
  mounted() {},
  data() {
    return {};
  },
  computed: {},
  components: {
    GalleryPanel,
    SlideMedia,
  },
  methods: {
    closeVideoPage() {
      this.$emit("closeView");
    },
  },
  async created() {
    await this.$store.dispatch("getMe");
  },
};
</script>
